<template>
    <div class="popsale-carousel" v-show="initialed">
        <transition name="fade">
            <img class="img-holder" :src="displaying" alt="Offer Photo" v-on:load="this.onload" v-show="loaded"/>
        </transition>

        <div class="popsale-carousel__dot" v-if="photos.length > 1">
            <div v-for="(photo, index) in this.photos" :data-index="index" class="dot" :class="{ 'is-active': isActive(index) }"></div>
        </div>
        <div class="popsale-carousel__arrow"  v-if="photos.length > 1">
            <button class="mdc-icon-button material-icons arrow-left" data-mdc-auto-init="MDCIconButtonToggle">keyboard_arrow_left</button>
            <button class="mdc-icon-button material-icons arrow-right"  data-mdc-auto-init="MDCIconButtonToggle">keyboard_arrow_right</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'photos': {
                type: Array,
                required: true
            }
        },
        computed: {
            'displaying': function () {
                try {
                    return this.photos[this.current].url
                } catch (e) {
                    return '/img/no-pic.png';
                }
            },
        },
        data: function () {
            return {
                'current': 0,
                'progressBar': $('.mdc-linear-progress')[0].MDCLinearProgress,
                'timer': null,
                'timeout': null,
                'loaded': false,
                'initialed': false,
            }
        },
        methods: {
            init: function () {
                window.mdc.autoInit();

                // Carousel handling
                $('.popsale-carousel__arrow').on('click', function (event) {

                    clearInterval(this.timer);

                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(function () {
                        this.createInterval();
                    }.bind(this), 10000);

                    let el = $(event.target);
                    let maxIndex = this.photos.length;

                    if (el.hasClass('arrow-left')) {
                        this.current = (this.current - 1) % maxIndex;
                    } else if (el.hasClass('arrow-right')) {
                        this.current = (this.current + 1) % maxIndex;
                    }
                    this.srcUpdate();
                }.bind(this));
            },
            'isActive': function (index) {
                return index === 0;
            },
            srcUpdate: function () {
                $('.dot.is-active').removeClass('is-active');
                $('.dot[data-index='+ this.current + ']').addClass('is-active');
            },
            createInterval: function () {
                if (this.photos.length < 2)  {
                    return;
                }

                clearInterval(this.timer);
                this.timer = setInterval(function () {
                    this.loaded = false;
                    this.current = (this.current + 1) % 2;
                    this.srcUpdate();
                }.bind(this), 10000);
            },
            onload: function () {
                this.loaded = true;
                this.initialed = true;
                this.progressBar.close();
                this.createInterval();
            }
        },
        mounted() {
            this.init();
            this.progressBar.open();
        }
    }
</script>

<style lang="scss">
    .popsale-carousel {
        position: relative;
        width: 100%;
        display: block;
        text-align: center;

        .img-holder {
            width: 60%;
            height: auto;
            align-items: center;
            justify-content: center;
        }

        .fade-enter-active {
            transition: opacity 1s ease-in-out;
        }

        .fade-enter-to, .fade-leave {
            opacity: 1;
        }

        .fade-enter, .fade-leave-to {
            opacity: 0;
        }


        .popsale-carousel__dot {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin-left: auto;
            margin-right: auto;

            .dot {
                display: inline-block;
                background-color: rgba(255, 255, 255, 0.5);
                /*border: black 1px solid;*/
                border-radius: 5px;
                width: 10px;
                height: 10px;
                margin-right: 5px;

                &.is-active {
                    background-color: white;
                }
            }
        }
    }

    .popsale-carousel .popsale-carousel__arrow {
        position: absolute;
        width: 100%;
        top: 50%;

        .mdc-icon-button.material-icons {
            position: absolute;
            &.arrow-left {
                left: 10px;
            }
            &.arrow-right {
                right: 10px;
            }
        }
    }
</style>